export default __webpack_public_path__ + "static/media/logo_proviso_white.1fe308c9.svg";